import { Col, Button } from "react-bootstrap";
import { Box } from "../../../components/box";
import FontFa from "../../../components/fontFa/fontFa";
import DataGrid, { Column, Export } from "devextreme-react/data-grid";
import { useCallback, useEffect, useMemo, useState } from "react";
import { withStatisticWapper } from "../statistics";
import { StatisticChart } from "../chart/index";
import { DocumentService } from "../../../services/document/document.service";
import LinkDocumentModal from "../../document/modal/link-document-modal";
import { getDDMMYYYFormat } from "../../../helper/dateTimeHelper";
import { getListIdByStatusValue } from "../../../services/serviceHelper";
import { mailRegexs } from "../../../constants/mailTemplateConstants";
import { useSelector } from "../../../store/store";
import { MailService } from "../../../services/mail/mail.service";
import { CreateNotification } from "../../../components/notifier";
import { getEnv } from "../../../AppConfigs";
import { useNonEmailUsers } from "../../document/hooks/published-documents/use-non-email-users";
import { RecentDistributionDocument } from "../distribution-document/recent-distribution-document";

export const StatisticReadDocumentDetailPage = withStatisticWapper(() => {
  const [document, setDocument] = useState<any>({});
  const [openLinkDocumentModal, setOpenLinkDocumentModalModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null as any);
  const [listId, setListId] = useState<any>(getListIdByStatusValue("", openLinkDocumentModal));
  const [data, setData] = useState<any>([]);
  const [peopleDocument, setPeopleDocument] = useState<any>([]);
  const [userNotReadArr, setUserNotReadArr] = useState<any>([]);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const documentDetailUrl = getEnv("REACT_APP_DOCUMENT_DETAILS_URL");

  const groupEmails = useMemo(() => {
    return (
      peopleDocument
        ?.filter((s: any) => s.email && s.jobTitle === "TKDC" && s.name !== "QLTL_GrTest")
        .map((s: any) => s.email) || []
    );
  }, [peopleDocument]);

  const { data: nonEmailUsers = [] } = useNonEmailUsers(groupEmails);

  const onPicked = (e: any) => {
    setSelectedDocument(e);
  };

  const getDocumentInfo = async () => {
    if (!selectedDocument) return;
    if (selectedDocument) {
      if (selectedDocument.docPublicEndUsers) setDocument(selectedDocument);
      else
        DocumentService.getPublicDocumentInfoFromWorkingDocument(selectedDocument.docWorkingId)
          .then((res) => {
            setDocument(res);
          })
          .catch((error) => {
            console.log(error);
          });
    }
  };

  const removeElements = (arr: any) => {
    return Array.from(new Set(arr.map((obj: any) => obj.email))).map((email) =>
      arr.find((obj: any) => obj.email === email),
    );
  };

  const getDocPublicEndUser = () => {
    const arr: any = document && document.fileAssignedTo ? JSON.parse(document.fileAssignedTo) : [];
    const primaryArr: any = removeElements(arr);
    primaryArr.shift();
    setPeopleDocument(primaryArr);
  };

  const toggleLinkDocumentModal = () => {
    setOpenLinkDocumentModalModal(!openLinkDocumentModal);
    setListId(getListIdByStatusValue("", !openLinkDocumentModal));
  };

  const findMissingElements = (array1: any, array2: any) => {
    return array2.filter((elem2: any) => !array1?.some((elem1: any) => elem1?.email === elem2?.email));
  };

  const sendMail = async (approver: any) => {
    const tomail = approver?.email;
    const name = approver?.name;
    const template = mailtemplates.find((m: any) => m.eMailType === "RTRTD");
    const url = `${documentDetailUrl}/${document.docWorkingId}?fileId=${document?.fileId}&status=publish&status=publish&action=info&index=2`;
    const content = template.eContent.replace(mailRegexs.zero, name).replace(mailRegexs.siteUrl, url);
    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const getData = useCallback(() => {
    let totalPeople =
      peopleDocument.length > 0
        ? peopleDocument.filter(
            (item: any) => item.email && !item.email.toLowerCase().startsWith("qltl_gr") && item.jobTitle !== "TKDC",
          ).length
        : 0;

    const readPeople = document.docReaders?.length > 0 ? document.docReaders?.length : 0;
    const readSharedPeople = document?.docReaders?.filter((item: any) => item.email).length;

    // if (readSharedPeople) {
    //   totalPeople += readSharedPeople;
    // }

    if (nonEmailUsers && nonEmailUsers?.length > 0) {
      totalPeople += nonEmailUsers.length;
    }

    const userNotReadArr = findMissingElements(document.docReaders, peopleDocument);
    setUserNotReadArr(userNotReadArr);
    return [
      {
        ID: 1,
        title: "Số CBNV được triển khai",
        soluong: totalPeople,
        percent: "1",
      },
      {
        ID: 2,
        title: "Số CBNV đã đọc",
        soluong: readPeople,
        percent: readPeople / totalPeople,
      },
      {
        ID: 3,
        title: "Số CBNV chưa đọc",
        percent: (totalPeople - readPeople) / totalPeople,
        soluong: totalPeople - readPeople,
      },
    ];
  }, [document.docReaders, nonEmailUsers, peopleDocument]);

  const handleRemind = () => {
    userNotReadArr.map((e: any) => sendMail(e));
    CreateNotification({
      title: "Thông báo",
      body: "Anh/Chị vừa gửi email nhắc nhở các user chưa đọc tài liệu",
      icon: "/icons/success.png",
    });
  };

  useEffect(() => {
    getDocumentInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDocument]);

  useEffect(() => {
    if (selectedDocument && document) getDocPublicEndUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document]);

  useEffect(() => {
    if (document && selectedDocument) setData(getData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document, peopleDocument]);

  return (
    <>
      <Box title="Tài liệu được triển khai gần đây">
        <RecentDistributionDocument setSelectedDocument={setSelectedDocument} />
      </Box>
      <Col sm={12} md={12} className="py-3">
        <Col className="py-3 statistic-header">
          <h3>TỶ LỆ NGƯỜI ĐỌC TÀI LIỆU</h3>
          <p>
            <i>Thống kê số lượng, tỷ lệ người dùng đã đọc thông tin/ chưa đọc thông tin được triển khai</i>
          </p>
          <div className="pt-1 d-flex">
            <h6 className="pt-2">Chọn một tài liệu để thống kê</h6>
            <div className="px-4 d-flex align-items-center">
              <Button
                title="Thống kê phân phối theo người dùng"
                className="btn mr-2"
                variant="outline-info"
                onClick={toggleLinkDocumentModal}
              >
                <FontFa name="faFilter" size={"xs"} />
              </Button>
            </div>
          </div>
        </Col>
      </Col>
      {selectedDocument && document && !openLinkDocumentModal && (
        <Col sm={12} md={12} className="py-3">
          <Col className="py-3 statistic-header box-statistic">
            <div className="pt-1">
              <h6>Tên tài liệu: {document.Title}</h6>
              <h6>Hiệu lực từ: {getDDMMYYYFormat(document.effectiveFrom)}</h6>
              <h6>Lần ban hành: {document.docPublishViewVersion}</h6>
              <h6>Lần sửa đổi: {document.docEditionVersion}</h6>
            </div>
          </Col>
          <Box
            title="Bảng thống kê"
            // titleRight={
            //   document &&
            //   peopleDocument.length > 0 && (
            //     <div className="px-4 py-2 d-flex align-items-center">
            //       {/* <Button disabled={true} title={'Xuất file'} className="mr-2" variant="outline-info"><FontFa name="faPrint" size={'xs'} /></Button> */}
            //       <Button
            //         title={"Nhắc nhở user đọc tài liệu"}
            //         className="mr-2"
            //         variant="outline-danger"
            //         onClick={() => handleRemind()}
            //       >
            //         <FontFa name="faEnvelope" size={"xs"} />
            //       </Button>
            //     </div>
            //   )
            // }
          >
            <Col className="py-2 px-4 d-flex justify-content-center">
              <DataGrid
                id="grid_content"
                dataSource={data}
                noDataText="Không tìm thấy tài liệu"
                showBorders={true}
                showRowLines={true}
                remoteOperations={true}
              >
                <Export enabled={true} />
                <Column caption="" dataField="title" dataType="string" width={400} />
                <Column alignment="center" caption="Số lượng" dataField="soluong" dataType="number" width={200} />
                <Column
                  alignment="center"
                  caption="Tỷ lệ"
                  dataField="percent"
                  dataType="number"
                  width={200}
                  format="percent"
                />
              </DataGrid>
            </Col>
          </Box>
          <Box title="Biểu đồ thống kê tỷ lệ triển khai">
            <Col className="d-flex align-item-center justify-content-center w-50">
              {document && data && <StatisticChart data={data} />}
            </Col>
          </Box>
        </Col>
      )}
      <LinkDocumentModal
        onClose={toggleLinkDocumentModal}
        isOpen={openLinkDocumentModal}
        isUrl={false}
        onPicked={onPicked}
        listId={listId}
      />
    </>
  );
});
